import { Component, Input, OnInit, HostBinding, ElementRef, AfterViewChecked, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/publishReplay';
import 'rxjs/add/operator/distinctUntilChanged';

@Component({
  selector: 'sts-alert',
  templateUrl: './alert.component.html'
})
export class AlertComponent implements OnInit, AfterViewInit, AfterViewChecked {

  message: string;
  type: string;
  icon: string;
  dismissible = true;
  inflated = false;
  showAlert = false;
  showIcon = false;

  private _data: AlertData;
  @Input()
  set data(data: AlertData) {
    this.ProcessData(data);
  }
  @HostBinding('style.display') display = 'block';

  constructor(
    private alertContainer: ElementRef,
    private changeDetection: ChangeDetectorRef
  ) { }


  ngOnInit() {
  }

  ngAfterViewInit() {
    Observable.fromEvent(window, 'resize')
      .map(() => { return this.IsAlertboxInflated(); })
      .startWith(this.IsAlertboxInflated())
      .publishReplay(1)
      .refCount()
      .distinctUntilChanged()
      .subscribe((val) => {
        this.inflated = val;
        this.changeDetection.detectChanges();
      });
  }

  ngAfterViewChecked() {
    if (this.inflated !== this.IsAlertboxInflated()) {
      this.inflated = !this.inflated;
      this.changeDetection.detectChanges();
    }
  }

  private IsAlertboxInflated() {
    if (this.alertContainer) {
      return this.alertContainer.nativeElement.offsetHeight > 56;
    } else {
      return false;
    }

  }

  private ProcessData(data: AlertData) {
    if (this._data !== data) {
      if (data) {
        this.message = data.message;

        // if type is not explicitly set, assume as info message.
        if (data.type) {
          this.type = data.type;
        } else {
          this.type = 'info';
        }

        switch (this.type) {
          case 'success':
            this.icon = 'fa-check'; break;
          case 'warning':
            this.icon = 'fa-warning'; break;
          case 'error':
            this.icon = 'fa-exclamation'; break;
          case 'info':
          default:
            this.icon = 'fa-info'; break;
        }

        // If this not explicitly set, assume we can close the alterbox.
        if (data.canDismiss === undefined) {
          this.dismissible = true;
        } else {
          this.dismissible = data.canDismiss;
        }

        // If this is not explicitly set, assume icon is visible.
        if (data.showIcon === undefined) {
          this.showIcon = true;
        } else {
          this.showIcon = data.showIcon;
        }

        this.showAlert = true;
      } else {
        this.message = '';
        this.type = 'info';
        this.dismissible = true;
        this.showAlert = false;
        this.showIcon = false;
      }
      this._data = data;
    }
  }

  private dismissAlert() {
    this.showAlert = false;
    this._data = undefined;
  }
}

export interface AlertData {
  message: string;
  type?: string;
  canDismiss?: boolean;
  showIcon?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/lib/alert/alert.component.ts